export default {
    title: 'Devices',
    subtitle: '{n} device | {n} devices',
    newDevice: 'New device',
    search: 'Search devices',
    add: {
        placeholder: 'Add a device…',
        save: 'Add',
    },
    kinds: {
        car: 'Car',
        appliance: 'Appliance',
        electronics: 'Electronics',
        home: 'Home',
        bike: 'Bike',
        other: 'Other',
    },
    fields: {
        name: 'Name',
        namePlaceholder: 'Name, e.g. Washing machine',
        kind: 'Kind',
        brand: 'Brand',
        brandPlaceholder: 'e.g. Bosch',
        model: 'Model',
        modelPlaceholder: 'e.g. Serie 6',
        purchasedOn: 'Bought on',
        warrantyUntil: 'Warranty until',
    },
    warranty: {
        title: 'Warranty',
        until: 'until {date}',
        endsIn: 'ends in {n} day | ends in {n} days',
        endsToday: 'ends today',
        ended: 'out of warranty',
        hint: 'Enter until when the device is under warranty — a month before, it shows up in “Right now”.',
    },
    mileage: {
        title: 'Mileage',
        last: '{km} km · {date}',
        perMonth: 'about {km} km/month on average',
        perMonthUnknown: 'the average needs two readings at least 2 weeks apart',
        empty: 'Enter the odometer reading now and then — it tells when a care “every N km” comes up.',
        add: 'Add reading',
        addCounter: 'Add odometer',
        km: 'Odometer',
        kmPlaceholder: 'e.g. 123400',
        date: 'Day',
        save: 'Save',
        cancel: 'Cancel',
        remove: 'Delete reading',
        all: 'All ({n})',
        less: 'Less',
    },
    costs: {
        title: 'Costs',
        total: 'on all care',
        empty: 'Enter a cost with “Done” and you’ll see the total here.',
    },
    notes: {
        title: 'Note',
        placeholder: 'Serial number, where to service it, filter size…',
    },
    empty: {
        title: 'No devices here yet',
        text: 'Add your car, washing machine or bike — services, inspections and the end of the warranty will remind themselves.',
        noMatchTitle: 'Nothing matches',
        noMatchText: 'Change the phrase or clear the search field.',
    },
    pick: {
        title: 'Pick a device',
        text: 'Or add a new one in the field above the list.',
    },
    toolbar: {
        back: 'Back to the list',
        remove: 'Delete device',
        saving: 'Saving…',
        saveError: 'Couldn’t save — we’ll try again with the next change',
    },
    toast: {
        removed: 'Deleted: {name}',
    },
    help: {
        add: {
            title: 'Add a device',
            text: 'Type a name, pick the kind and press Enter. Fill in the rest on the right.',
            more: 'The assistant adds a device too when you say e.g. “the washing machine’s warranty runs until May 2028”.',
        },
        list: {
            title: 'Your devices',
            text: 'Those with the nearest care on top. Badges say what and when, and whether the warranty is ending.',
            more: 'An orange badge means the date has passed or the warranty ends within a month. The amount on the right is the total cost.',
        },
        cares: {
            title: 'Care',
            text: 'Service, oil change, descaling… Set how many months apart, and “Done” saves the day and cost and moves the next date.',
            more: 'You can also set the date by hand — it holds until the next “Done”. A week before, the care shows up in “Right now” and in the Planner.',
        },
        warranty: {
            title: 'Warranty',
            text: 'The day until which the device is under warranty. A month before it ends, it shows up in “Right now”.',
            more: 'The purchase date is next to it — handy for a complaint.',
        },
        costs: {
            title: 'Costs',
            text: 'The total cost of all the care done and how much went on each.',
            more: 'Single amounts are in the history next to the care.',
        },
    },
    tour: {
        welcome: {
            title: 'Welcome to Devices',
            description: 'A place for things you look after: car, washing machine, bike. Services, costs and warranty in one place.',
        },
        device: {
            title: 'Device',
            description: 'On the right: name, kind, brand and model, warranty, care with the “Done” button, costs and a note. Everything saves itself.',
        },
        end: {
            title: 'That’s all',
            description: 'The guide is always under “Help” — First steps are there too. And “What’s this?” next to a section explains it without the guide.',
        },
    },
    firstSteps: {
        device: {
            title: 'First device',
            action: 'Add a device',
            what: 'Type a name in “Add a device…”, pick the kind and press Enter.',
            why: 'Care, costs and warranty belong to the device.',
        },
        care: {
            title: 'Care',
            action: 'Add care',
            what: 'Open the device and add e.g. a service or descaling — from the suggestions or under your own name.',
            why: 'The date will remind you in “Right now” and in the Planner.',
        },
        done: {
            title: 'Done',
            action: 'Save it as done',
            what: 'Click “Done” next to a care item — with the day, cost and a note.',
            why: 'The next date counts from that day, and the cost adds to the total.',
        },
        warranty: {
            title: 'Warranty',
            action: 'Enter the warranty',
            what: 'Enter until when the device is under warranty.',
            why: 'A month before it ends, it shows up in “Right now”.',
        },
    },
};
